import React, {Component} from 'react';
import { NavLink, withRouter } from 'react-router-dom';

import { Row, Col } from 'antd';

import './Support.css';
import dropdown from './imgs/drop_down.svg';

class Support extends Component {

  state={
    dropDown: false,
  };

  handleSwitch = () => {
    this.setState({
      dropDown: !this.state.dropDown,
    });
  };

  render () {
    return (
      <div className="Support">
        <div className="SubHeader">
          <h2>Support</h2>
        </div>
        <div className="Link">
          <div className="Menu" onClick={this.handleSwitch}>
            {this.props.location.pathname === '/support' ? 'Support' :
              this.props.location.pathname === '/feedback' ? 'Feedback' :
                this.props.location.pathname === '/ios-update' ? 'iOS Update' :
                  this.props.location.pathname === '/android-update' ? 'Android Update' : ''
            }
            <img
              src={dropdown}
              alt="Drop Down"
              style={this.state.dropDown ? {transform: 'rotate(180deg)'} : {}}
            />
          </div>
          <Row id={this.state.dropDown ? 'dropDown' : ''}>
            <Col span={6}>
              <NavLink to="/ios-update" activeStyle={{opacity: 1}}>
                iOS Update
              </NavLink>
            </Col>
            <Col span={6}>
              <NavLink to="/android-update" activeStyle={{opacity: 1}}>
                Android Update
              </NavLink>
            </Col>
            <Col span={6}>
              <NavLink to="/support" activeStyle={{opacity: 1}}>
                Support
              </NavLink>
            </Col>
            <Col span={6}>
              <NavLink to="/feedback" activeStyle={{opacity: 1}}>
                Feedback
              </NavLink>
            </Col>
          </Row>
        </div>
      </div>
    )
  }
}

export default withRouter(Support);


// WEBPACK FOOTER //
// ./src/Containers/Support/Support.js